
export const CasualLeaveVI = {
    casualLeave: {
        edit : {
            type : "Chọn loại phép",
            dateDuplicate : "Cùng loại không được trùng ngày!"
        },
        breadcrumb: {
            year: "Quản lý phép",
            month: "Danh sách nghỉ phép theo tháng",
            personnel: "THÔNG TIN PHÉP NĂM"
        },
        subTitle: {
            year: "Bảng phép năm",
            month: "Bảng phép từ",
            showAllUser : "Hiện tất cả nhân viên",
        },
        header: {
            generalInformation: "Thông tin chung",
            history: "Lịch sử sử dụng",
            personnel: "Thông tin cá nhân",
            year: "Thông tin phép năm",
            month: "Thông tin phép tháng",
            detail: "Chi tiết"
        },
        action: {
            type: {
                year: "Xem theo năm",
                month: "Xem theo tháng"
            },
            recalculate: "Tính toán lại",
            updateLeave: "Sửa phép trực tiếp"
        },
        word: {
            to: "đến"
        },
        message: {
          required: {
              fromDate: "Ngày là trường bắt buộc!",
              leave: "Số lượng là trường bắt buộc!",
              type: "Loại là trường bắt buộc!"
          }
        },
        label: {
            employee: {
                name: "Họ và tên",
                code: "Mã NS"
            },
            departmentName: "Phòng ban",
            jobPositionName: "Vị trí",
            jobTitleName: "Chức vụ",
            balanceTotal: "Tổng tồn",
            fromDate:"Từ ngày",
            type: "Loại",
            leaves: "Số lượng",
            leave: {
                total: "Tổng",
                expired: "Hết hạn",
                used: "Sử dụng",
                balance: "Tồn cuối"
            },
            totalLeave: "Tổng phép",
            accumulationLeave: "Phép lũy kế",
            seniorityLeave: "Phép thâm niên",
            annualLeave: "Phép năm",
            advancedLeave: "Phép ứng",
            year: "Năm",
            month: "Tháng",
            amount: "Số lượng",
            date: "Ngày",
            reason: "Lý do",
            expiredDate: "Ngày hết hạn",
            status: "Trạng thái"
        },
        description: {
            updateLeave: "Bạn nên cập nhật phép vào đầu của kỳ"
        },
        value: {
            reason: {
                create: {
                    annual: "Cộng phép năm",
                    seniority: "Cộng phép thâm niên",
                    accumulation: "Cộng phép lũy kế",
                    accumulation_expired: "Phép lũy kế hết hạn",
                },
                update: {
                    annual: "Sửa trực tiếp phép năm",
                    seniority: "Sửa trực tiếp phép thâm niên",
                    accumulation: "Sửa trực tiếp phép lũy kế",
                    used: "Sửa trực tiếp phép sử dụng"
                },
                delete: {
                    application_leave: "Trừ phép đơn xin nghỉ"
                }
            },
            working: {
                Working: "Đang làm việc",
                Resignation: "Nghỉ việc",
                Waiting: "Chờ nhận việc",
                Droptemp: "Nghỉ tạm thời",
            },
            type: {
                annual: "Phép năm",
                seniority: "Phép thâm niên",
                accumulation: "Phép lũy kế",
                used: "Phép sử dụng"
            }
        },
        unit: {
            leave: {
                day: "ngày"
            }
        },
        notify:{
            calEmployee : "Xin vui lòng chờ ít phút để hệ thống tính toán lại phép năm cho nhân sự"
        }
    }
}
